/**
 * Asset constants for requesting the beackend api
 */

const Asset = {
    COMMENT: 'comment',
    CONTENT: 'content',
    PCMMEDIA: 'pcmMedia',
    STORY: 'story'
};

export {Asset};
